import { ReactElement } from "react";
import {
  FieldPath,
  FieldValues,
  UseControllerProps,
  UseControllerReturn,
  useController,
} from "react-hook-form";

export interface FormFieldControlProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends UseControllerProps<TFieldValues, TName> {
  children: ({
    field,
    fieldState,
  }: UseControllerReturn<TFieldValues, TName>) => ReactElement;
}

export const FormFieldControl = <
  T extends FieldValues,
  S extends FieldPath<T> = FieldPath<T>,
>(
  props: FormFieldControlProps<T, S>
): ReactElement => {
  const { children, ...rest } = props;

  const { ...state } = useController(rest);

  return <>{children({ ...state })}</>;
};
